


// function blogFind(datHref, event) {
//   var __this = event;
//   document.querySelectorAll("#menu .active").forEach((el) => el.classList.remove("active"));
//   __this.classList.add('active');
  
//   fetch(datHref)
//     .then((response) => response.text())
//     .then((responseText) => {
//       let html = new DOMParser().parseFromString(responseText, "text/html");
//       let targetElement = document.querySelector(".blog-articles ");
//       let sourceElement = html.querySelector(".blog-articles ");
      
//       if (targetElement && sourceElement) {
//         targetElement.replaceWith(sourceElement);
//       }
//     });
// }

// function blogpagination(event, datHref) {
//   let nextPage = event.target.getAttribute("data-currentpage");
//   let maxPage = event.target.getAttribute("data-totalpage");
//   let dataurl = `${datHref}?page=${nextPage}`;

//   fetch(dataurl)
//     .then((response) => response.text())
//     .then((responseText) => {
//       let html = new DOMParser().parseFromString(responseText, "text/html");
//       let targetElement = document.querySelector(".blog-articles");
//       let sourceElement = html.querySelectorAll(".blog-articles__article");

//       sourceElement.forEach((article) => {
//         if (targetElement) {
//           targetElement.appendChild(article);
//         }
//       });

//       event.target.setAttribute("data-currentpage", Number(nextPage) + 1);
//     })
//     .finally(() => {
//       if (nextPage == maxPage) {
//         event.target.remove();
//       }
//     });
// }



function blogFind(datHref, event) {
  var __this = event;
  document.querySelectorAll("#menu .active").forEach((el) => el.classList.remove("active"));
  __this.classList.add('active');
  
  fetch(datHref)
    .then((response) => response.text())
    .then((responseText) => {
      let html = new DOMParser().parseFromString(responseText, "text/html");
      
      // Refresh the .blog-articles content
      let targetElement = document.querySelector(".blog-articles");
      let sourceElement = html.querySelector(".blog-articles");
      if (targetElement && sourceElement) {
        targetElement.replaceWith(sourceElement);
      }

      // Refresh the .block_blog_load_more_flex content
      let blockTargetElement = document.querySelector(".block_blog_load_more_flex");
      let blockSourceElement = html.querySelector(".block_blog_load_more_flex");
      if (blockTargetElement && blockSourceElement) {
        blockTargetElement.replaceWith(blockSourceElement);
      }
    });
}

function blogpagination(event, datHref) {
  let nextPage = event.target.getAttribute("data-currentpage");
  let maxPage = event.target.getAttribute("data-totalpage");
  let dataurl = `${datHref}?page=${nextPage}`;

  fetch(dataurl)
    .then((response) => response.text())
    .then((responseText) => {
      let html = new DOMParser().parseFromString(responseText, "text/html");

      // Append new blog articles
      let targetElement = document.querySelector(".blog-articles");
      let sourceElement = html.querySelectorAll(".blog-articles__article");

      sourceElement.forEach((article) => {
        if (targetElement) {
          targetElement.appendChild(article);
        }
      });

      event.target.setAttribute("data-currentpage", Number(nextPage) + 1);
    })
    .finally(() => {
      // If we have reached the max page, remove the "Load More" button
      if (nextPage == maxPage) {
        event.target.remove();
      }

      // Refresh the .block_blog_load_more_flex content as well
      let blockTargetElement = document.querySelector(".block_blog_load_more_flex");
      let blockSourceElement = html.querySelector(".block_blog_load_more_flex");
      if (blockTargetElement && blockSourceElement) {
        blockTargetElement.replaceWith(blockSourceElement);
      }
    });
}





